<div class="slug-edit-dialog">
  <p class="slug-edit-dialog__error ui-input__error" *ngIf="errorMessage">{{ errorMessage }}</p>
  <form [formGroup]="form" (ngSubmit)="onSave()">
    <div class="ui-input__placeholder">
      <p>Slug</p>
    </div>
    <div class="ui-input ui-input__text" [class.error]="form.get('slug').invalid && form.get('slug').touched">
      <input
        type="text"
        formControlName="slug"
        placeholder="muzrus.com/"
        maxlength="100"
        (input)="onSlugInput($any($event.target).value)"
      />
    </div>
    <p class="txt-caption slug-edit-dialog__hint">Только строчные латинские буквы, цифры и дефисы, 3–100 символов</p>
    <p class="ui-input__error" *ngIf="form.get('slug').invalid && form.get('slug').touched">
      {{ form.get('slug').errors?.slugTaken ? 'Этот адрес страницы уже занят' : 'Только строчные латинские буквы, цифры и дефисы, 3–100 символов' }}
    </p>
    <div class="slug-edit-dialog__actions">
      <button type="button" class="ui-buttons ui-buttons__light-small" (click)="onCancel()" [disabled]="saving">
        Отмена
      </button>
      <button type="submit" class="ui-buttons ui-buttons__blue-small" [disabled]="form.invalid || saving">
        {{ saving ? 'Сохранение...' : 'Сохранить' }}
      </button>
    </div>
  </form>
</div>
